module.exports = __webpack_public_path__ + "static/img/neoCode.e33eac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neoCode.png
// module id = jqSA
// module chunks = 89